import React from 'react';
import SearchIcon from '../../../../images/icon-search.svg';
import styles from '../LocationsForNewLocationAvailability.module.css';

interface LocationSearchBoxProps {
    searchText: string;
    onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onChange: (event: React.FormEvent<HTMLInputElement>) => void;
}

/**
 * Search Box Component for Location Search
 * Provides input field with search icon for filtering locations
 */
const LocationSearchBox: React.FC<LocationSearchBoxProps> = ({ 
    searchText, 
    onKeyPress, 
    onChange 
}) => {
    return (
        <div className={styles.searchBox}>
            <input
                value={searchText || ''}
                onKeyPress={onKeyPress}
                onChange={onChange}
                type="text"
                placeholder="Search for property"
                maxLength={50}
                aria-label="Search for property"
            />
            <img 
                className={styles.searchIconImage} 
                src={SearchIcon} 
                alt="search-icon" 
            />
        </div>
    );
};

export default LocationSearchBox;

